exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav__notifications-menu {\n  max-width: 800px;\n}\n.nav__notifications-content {\n  color: #2C3030;\n  font-size: 18px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 21.6px;\n  font-family: \"Inter\", \"Rubik\", Arial, sans-serif;\n  white-space: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd97f58e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/navigation/Navbar.vue
// module id = Kl9B
// module chunks = 1